import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
export default {
  name: "VirtualTree",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    defaultExpandAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      flattenData: [],
      visibleNodes: [],
      offsetY: 0,
      totalHeight: 0,
      itemHeight: 35
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.userInfo.isAdmin === "T";
    }
  },
  watch: {
    data: {
      handler() {
        this.buildTree();
      },
      deep: true
    }
  },
  mounted() {
    this.initContainer();
    this.buildTree();
  },
  methods: {
    initContainer() {
      this.$nextTick(() => {
        const container = this.$refs.containerRef;
        if (container) {
          container.addEventListener("scroll", this.onScroll, {
            passive: true
          });
        }
      });
    },
    buildTree() {
      // 扁平化树数据
      this.flattenData = this.flattenTree(this.data, 0);
      this.totalHeight = this.flattenData.length * this.itemHeight;
      this.updateVisibleNodes();
    },
    flattenTree(nodes, depth = 0, result = []) {
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
        node.depth = depth;
        result.push(node);
        if (node.expand && node.children && node.children.length > 0) {
          this.flattenTree(node.children, depth + 1, result);
        }
      }
      return result;
    },
    hasChildren(node) {
      return node.children && node.children.length > 0;
    },
    toggleNode(node) {
      node.expand = !node.expand;
      this.buildTree();
    },
    handleNodeClick(node) {
      // 清除之前的选中状态
      this.flattenData.forEach(n => {
        if (n.checked) {
          n.checked = false;
        }
      });
      node.checked = true;
      this.$emit("onChange", node);
      // 触发视图更新
      this.visibleNodes = [...this.visibleNodes];
    },
    onScroll() {
      this.updateVisibleNodes();
    },
    updateVisibleNodes() {
      const container = this.$refs.containerRef;
      if (!container || this.flattenData.length === 0) return;

      // 动态获取容器高度
      const containerHeight = container.clientHeight;
      const scrollTop = container.scrollTop;
      const startIndex = Math.max(0, Math.floor(scrollTop / this.itemHeight));
      const endIndex = Math.min(this.flattenData.length, Math.ceil((scrollTop + containerHeight) / this.itemHeight) + 1);
      this.visibleNodes = this.flattenData.slice(startIndex, endIndex);
      this.offsetY = startIndex * this.itemHeight;
    }
  },
  beforeDestroy() {
    const container = this.$refs.containerRef;
    if (container) {
      container.removeEventListener("scroll", this.onScroll);
    }
  }
};